export default __webpack_public_path__ + "static/10-14fdf1761cc0910d0c67fd2f65633e09.jpg";